import React from 'react';
import { Button } from '@noths/polaris-design-system-core-components';

import * as styles from './PreviewHeader.styles';

export interface PreviewHeaderProps {
  href: string;
}

export const PreviewHeader = ({ href }: PreviewHeaderProps) => (
  <header css={styles.container}>
    <Button compact href={href}>
      Exit Preview
    </Button>
  </header>
);
